<script lang="ts">
	import { Auth } from "@utils/Auth.svelte.js";
	import { clarityConsent, clarityTag, initClarity } from "@utils/clarity.js";
	import { onMount } from "svelte";
	import { on } from "svelte/events";
	import { getGlobalSettings } from "../../contexts/getGlobalSettings.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";
	import { selectedCurrency } from "../../state/selectedCurrency.svelte.js";
	import { selectedDestinationCountry } from "../../state/selectedDestinationCountry.svelte.js";

	const settings = getGlobalSettings();
	const { template, tenant, pricingLevel } = getGlobalTemplateProps();

	function applyConsent(categories: readonly CookieScriptCategory[]): void {
		clarityConsent({
			analytics: categories.includes("performance"),
			ads: categories.includes("targeting"),
		});
	}

	function processState(): void {
		const state = CookieScript.instance.currentState();
		applyConsent(state.action === "accept" ? (state.categories ?? []) : []);
	}

	function start(): void {
		initClarity(settings);
		processState();
		clarityTag("template", template);
		clarityTag("locale", tenant.locale);
		clarityTag("pricingLevel", pricingLevel);
	}

	onMount(() => {
		if (window.CookieScript?.instance) {
			start();
			return;
		}
		return on(window, "CookieScriptLoaded", start, { once: true });
	});
	onMount(() =>
		on(window, "CookieScriptAccept", (e) => {
			applyConsent(e.detail.categories ?? []);
		}),
	);
	onMount(() =>
		on(window, "CookieScriptReject", () => {
			applyConsent([]);
		}),
	);

	$effect(() => {
		clarityTag("loggedIn", String(Auth.signedIn));
	});
	$effect(() => {
		clarityTag("familyClubMember", String(Auth.isFfcMember));
	});
	$effect(() => {
		if (selectedCurrency.current !== undefined) {
			clarityTag("currency", selectedCurrency.current);
		}
	});
	$effect(() => {
		if (selectedDestinationCountry.current !== null) {
			clarityTag("destinationCountry", selectedDestinationCountry.current);
		}
	});
</script>
